import { CarPdfViewer } from "@app/components/PdfViewer";
import { CarPdfDocument } from "@app/components/PdfDocument";
import { CarPdfPage, defaultClientPageSize } from "@app/components/PdfPage";
import { useUser } from "@app/pages/settings/useUser";
import { usePortfolioGroupInfo } from "@app/pages/assetAllocation/usePortfolioGroupInfo";
import { usePortfolioGroupVersionStatData } from "@app/pages/assetAllocation/usePortfolioGroupVersionStatData";
import { MultiPeriodReturnPdfChart } from "@app/pages/assetClassAnalysis/pdfMultiPeriodReturnReport/MultiPeriodReturnPdfChart";
import { MultiPeriodReturnPdfTable } from "@app/pages/assetClassAnalysis/pdfMultiPeriodReturnReport/MultiPeriodReturnPdfTable";

const CHART_HEIGHT = 248;

interface ModuleMultiPeriodReturnReportProps {
  portfolioGroupId: string;
  moduleId: string;
  data1Id: string;
  data2Id: string;
  footer: string;
}

export const ModuleMultiPeriodReturnReport = ({
  portfolioGroupId,
  moduleId,
  data1Id,
  data2Id,
  footer,
}: ModuleMultiPeriodReturnReportProps) => {
  const groupInfo = usePortfolioGroupInfo({ portfolioGroupId });

  const { portfolioGroupVersionId, publishedVersionId, isSinglePortfolioMode } =
    groupInfo;

  const statData = usePortfolioGroupVersionStatData({
    versionId: portfolioGroupVersionId,
    publishedVersionId,
    filterByModuleId: moduleId,
  });

  const user = useUser();

  const moduleName = statData.getModuleNameById(moduleId);

  const title = `Multi-Period Return - ${isSinglePortfolioMode ? groupInfo.title : moduleName}`;

  return (
    <CarPdfViewer
      isLoading={user.isLoading || groupInfo.isLoading || statData.isLoading}
    >
      <CarPdfDocument title={title} author={user.userFullName}>
        {
          <CarPdfPage
            sectionTitle="Analyze"
            reportTitle={title}
            footer={footer}
          >
            <MultiPeriodReturnPdfChart
              style={{ marginTop: 28 }}
              width={defaultClientPageSize.width}
              height={CHART_HEIGHT}
              data={statData.multiPeriodReturnComparison}
              data1Id={data1Id}
              data2Id={data2Id}
              isWhiteContext
            />
            <MultiPeriodReturnPdfTable
              style={{ marginTop: 30 }}
              data={statData.multiPeriodReturnComparison}
              data1Id={data1Id}
              data2Id={data2Id}
            />
          </CarPdfPage>
        }
      </CarPdfDocument>
    </CarPdfViewer>
  );
};
